'use strict';
angular.module('schoolLinqApp').directive('ssnInput', [
	'$filter',
	'$browser',
	function ($filter, $browser) {
		return {
			require: 'ngModel',
			link: function ($scope, $element, $attrs, ngModelCtrl) {
				var minLength = 9;
				var minFormattedLength = 11;

				var listener = function () {
					let selectionStart = $element[0].selectionStart;
					let selectionEnd = $element[0].selectionEnd;
					let skipDash = 0;

					let isValidInput = false;
					// valid input is 0-9
					if (!$element[0].shiftKey && 48 <= $element[0].lastKeyCode && $element[0].lastKeyCode <= 57) {
						isValidInput = true;
					}
					// valid input is 0-9 (on NumPad)
					if (96 <= $element[0].lastKeyCode && $element[0].lastKeyCode <= 105) {
						isValidInput = true;
					}

					let value = $element.val().replace(/[^0-9]/g, '');
					$element.val($filter('ssn')(value, false));

					// if there is nothing in the ssn input box then don't set the "invalid" error (ssnComplete)...
					// in this case the "required" error is what we want instead.
					let bSsnComplete = $element.val().length === 0 ? true : $element.val().length === minFormattedLength;
					ngModelCtrl.$setValidity('ssnComplete', bSsnComplete);

					// if the last key pressed was the tab key then don't reposition the cursor
					// because doing so causes problems for IE browsers (ie. they won't move the
					// cursor to the next element on the form).
					if ($element[0].lastKeyCode !== 9) {
						if (isValidInput) {
							// if the previous char was a . OR the next char is a . then skip over it.
							if ($element[0].value[selectionEnd - 1] === '-' || $element[0].value[selectionEnd] === '-') skipDash = 1;

							$element[0].selectionStart = selectionStart + skipDash;
							$element[0].selectionEnd = selectionEnd + skipDash;
						} else {
							// if the last key was a backspace or delete or Enter key then we don't need to manually move the cursor back.
							if ($element[0].lastKeyCode === 8 || $element[0].lastKeyCode === 46 || $element[0].lastKeyCode === 13) {
								$element[0].selectionStart = selectionStart;
								$element[0].selectionEnd = selectionEnd;
							}
							// if the last key was a . (110 or 190) and previous char in the mask was a . then we don't need to manually move the cursor back.
							else if (
								($element[0].lastKeyCode === 109 || $element[0].lastKeyCode === 189) &&
								$element[0].value[selectionEnd - 1] === '-'
							) {
								$element[0].selectionStart = selectionStart;
								$element[0].selectionEnd = selectionEnd;
							}
							// if its not valid input (0-9) then backup the cursor by one since we just ate the invalid key.
							else {
								$element[0].selectionStart = selectionStart - 1;
								$element[0].selectionEnd = selectionEnd - 1;
							}
						}
					}
				};

				// This runs when we update the text field
				ngModelCtrl.$parsers.push(function (viewValue) {
					viewValue = viewValue.replace(/[^0-9]/g, '').slice(0, 9);
					let bSsnComplete = viewValue.length === 0 ? true : viewValue.length === minLength;
					ngModelCtrl.$setValidity('ssnComplete', bSsnComplete);
					return viewValue;
				});

				// This runs when the model gets updated on the scope directly and keeps our view in sync
				ngModelCtrl.$render = function () {
					$element.val($filter('ssn')(ngModelCtrl.$viewValue, false));
					let bSsnComplete = $element.val().length === 0 ? true : $element.val().length === minFormattedLength;
					ngModelCtrl.$setValidity('ssnComplete', bSsnComplete);
				};

				$element.bind('change', listener);
				$element.bind('keydown', function (event) {
					var keyCode = event.keyCode;
					// save these values off for use later in the listener function.
					this.lastKeyCode = keyCode;
					this.shiftKey = event.shiftKey;

					// If the keys include the INSERT, CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
					// This lets us support copy and paste too
					if (keyCode === 45 || keyCode === 91 || (15 < keyCode && keyCode < 19) || (33 <= keyCode && keyCode <= 40)) {
						return;
					}
					$browser.defer(listener); // Have to do this or changes don't get picked up properly
				});

				$element.bind('paste cut', function () {
					$browser.defer(listener);
				});
			},
		};
	},
]);
